var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1739 1.83327C13.8468 1.83325 12.9914 1.99134 12.0108 2.47132C11.6478 2.64902 11.3072 2.86303 10.9909 3.1127C10.6868 2.87702 10.3598 2.67284 10.0117 2.50071C9.01212 2.0063 8.11284 1.83325 6.83341 1.83325C3.40681 1.83325 0.916748 4.67241 0.916748 8.3598C0.916748 11.1445 2.46943 13.8345 5.36152 16.4357C6.87957 17.801 8.81779 19.1521 10.2059 19.8709L11.0001 20.2822L11.7943 19.8709C13.1824 19.1521 15.1206 17.801 16.6386 16.4357C19.5307 13.8345 21.0834 11.1445 21.0834 8.3598C21.0834 4.71144 18.5699 1.84733 15.1739 1.83327ZM19.2501 8.3598C19.2501 10.5415 17.9541 12.7868 15.4127 15.0725C14.0271 16.3187 12.2458 17.5641 11.0001 18.2175C9.75437 17.5641 7.97308 16.3187 6.5875 15.0725C4.04608 12.7868 2.75008 10.5415 2.75008 8.3598C2.75008 5.63533 4.47675 3.66659 6.83341 3.66659C7.85067 3.66659 8.47753 3.78721 9.19895 4.14402C9.62509 4.35479 10.0017 4.63309 10.3277 4.98088L11.0022 5.7004L11.6706 4.97517C12.0039 4.61346 12.3861 4.32882 12.8168 4.11798C13.5171 3.7752 14.1048 3.66659 15.1701 3.66659C17.4976 3.67624 19.2501 5.67314 19.2501 8.3598Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bb81ebbc94ff5b6ceb989cd3eb5e5365.svg";
export { ForwardRef as ReactComponent };